import React, { useCallback, useEffect, useRef, useState } from "react";
import api, { fileUrl } from "../lib/api";

const TIER = {
  gold: { border: "border-jam-gold", text: "text-jam-gold", crown: "👑", label: "TOP GIFTER", bg: "bg-jam-gold/20" },
  silver: { border: "border-slate-300", text: "text-slate-200", crown: "🥈", label: "#2 SUPPORTER", bg: "bg-slate-300/20" },
  bronze: { border: "border-amber-600", text: "text-amber-400", crown: "🥉", label: "#3 SUPPORTER", bg: "bg-amber-600/20" },
};

export default function TopGifterEntrance({ sessionId }) {
  const sinceRef = useRef(null);
  const queueRef = useRef([]);
  const seenRef = useRef(new Set());
  const playing = useRef(false);
  const [cur, setCur] = useState(null);

  const playNext = useCallback(() => {
    if (playing.current) return;
    const n = queueRef.current.shift();
    if (!n) return;
    playing.current = true;
    setCur(n);
    setTimeout(() => { playing.current = false; setCur(null); if (queueRef.current.length) playNext(); }, 3200);
  }, []);

  const poll = useCallback(async () => {
    try {
      const q = sinceRef.current ? `?since=${encodeURIComponent(sinceRef.current)}` : "";
      const { data } = await api.get(`/live/${sessionId}/entrances${q}`);
      sinceRef.current = data.server_time;
      for (const e of data.entrances || []) {
        if (seenRef.current.has(e.id)) continue;
        seenRef.current.add(e.id);
        queueRef.current.push(e);
      }
      if (queueRef.current.length) playNext();
    } catch { /* ignore */ }
  }, [sessionId, playNext]);

  useEffect(() => {
    if (!sessionId) return;
    poll();
    const t = setInterval(poll, 3000);
    return () => clearInterval(t);
  }, [sessionId, poll]);

  if (!cur) return null;
  const tier = TIER[cur.tier] || TIER.gold;
  return (
    <div data-testid="top-gifter-entrance" className="pointer-events-none flex justify-center">
      <div className={`animate-fade-up flex items-center gap-2 rounded-full border ${tier.border} ${tier.bg} pl-2 pr-4 py-1.5 backdrop-blur-md`}>
        <span className="text-xl">{tier.crown}</span>
        <div className={`w-8 h-8 rounded-full overflow-hidden bg-white/15 flex items-center justify-center border-2 ${tier.border}`}>
          {cur.avatar_path ? <img src={fileUrl(cur.avatar_path)} alt="" className="w-full h-full object-cover" /> : <span className="text-cream font-black text-xs">{(cur.username || "?")[0]?.toUpperCase()}</span>}
        </div>
        <div className="min-w-0">
          <p className={`text-[9px] font-black tracking-widest ${tier.text}`}>{tier.label}</p>
          <p className="text-cream text-xs font-black truncate">@{cur.username} {cur.reason === "crown" ? "took the crown!" : "entered"}</p>
        </div>
      </div>
    </div>
  );
}
